// https://github.com/facebook/react/issues/14010#issuecomment-433788147
import Dashboard from 'assets/js/classes/Dashboard'
import FrontendRoutes from 'assets/js/classes/FrontendRoutes'
import handleToast from './handleToast'

// eventTaskUpdated(data, modelContext, toastsContext)
export default function eventTaskUpdatedViewDashboard({ author, user, task }, { dashboard, searchBar }, { toasts, toastsDispatch, updateToasts, navigate }) {  
  // if ([...Object.values(Dashboard.eventGetTaskIndex(task, dashboard.dataset))].find(el => el === -1)) return;  // If task isn't loaded via API call yet.
  
  [dashboard, searchBar].forEach(({ dataset, dispatch, prop, update }) => {
    Dashboard.eventTaskUpdated(task, dataset);
    Dashboard.removeArchivedTask(task, dataset);
    update(dispatch, { [prop]: dataset });
  });
  
  if (author?.id === user?.id) return;  // Don't throw toast.

  handleToast({
    title: 'Task Updated', 
    message: `Task #${task?.id} was updated by ${author?.name} (${author?.email}). The latest version has automatically been loaded for you.`,
    autohide: true, 
    label: 'View Task', 
    callback: () => navigate(FrontendRoutes.PROJECTS_TASK(task?.id)), 
  }, { toasts, toastsDispatch, updateToasts });
}